import React from 'react';
import { splitLinks, NEW_TAB_NOTE } from '../../utils/chatText';

/**
 * Plain text with web links made clickable. Links open in a new tab so a call or chat
 * is never navigated away from, and screen readers are told so.
 */
export default function LinkifiedText({ text }) {
    return splitLinks(text).map((part, index) => {
        if (!part.href) {
            return <React.Fragment key={index}>{part.text}</React.Fragment>;
        }
        return (
            <a key={index} href={part.href} target="_blank" rel="noopener noreferrer">
                {part.text}
                <span className="sr-only"> {NEW_TAB_NOTE}</span>
            </a>
        );
    });
}
